import StorageService from 'services/StorageService/StorageService';

const refreshTokenStorage = new StorageService('refresh_token');

export default refreshTokenStorage;
